var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"size":"mini","resizable":"","auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":500},scopedSlots:_vm._u([{key:"displayAvatar",fn:function(ref){
var row = ref.row;
return [_c('el-avatar',{attrs:{"shape":"square","size":50,"src":row.memImgUrl || _vm.defaultAvatar}})]}},{key:"displayName",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(_vm._s(row.userName))]),_c('div',[_vm._v(_vm._s(row.userPost))])]}},{key:"displayContacts",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(_vm._s(row.mobileNumber))]),_c('div',[_vm._v(_vm._s(row.emailAddress))])]}},{key:"modifyInfo",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(_vm._s(row.modifyByName))]),_c('div',[_vm._v(_vm._s(row.modifyDate))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }